<template>
  <!-- finish字段是为了解决需要调用接口才能知晓是默认还是自定义，使用这个需要等到解决获取数据再进行页面判断避免不走if，而开始就走else的异步问题 -->
  <div class="red-map-coverImg" v-if="finish">
    <!-- 点击图片进入 -->
    <div class="entryPageCust" v-if="coverUrl" :style="{ 'background-image': 'url(' + coverUrl + ')' }" @click="handleClick">
      <!-- <button class="entry-map" @click="handleClick">点击进入地图</button> -->
    </div>
    <div class="entryPageBox" v-else>
      <div class="centuryYearBox">
        <img src="../../assets/images/title_entery.png" alt="" class="images" />
      </div>
      <div class="content">
        <div class="mainBox">
          <div class="tabBox">
            <div class="tabTitle">选择您要浏览的内容</div>
            <div class="tabMainBox">
              <div class="tabList" v-if="activityInfo.mapStyle.fnModule.citySearch && activityInfo.mapStyle.fnModule.citySearch.check">
                <div class="tabListSelect" @click="openCity()">
                  <!-- 省下拉 -->
                  {{ selectedCity.value }}
                  <i class="selectIcon"></i>
                </div>
              </div>
              <div class="tabList" v-for="(item, idx) in selectCateList" :key="idx" @click="chooseTab(item)">
                <div
                  class="tabListBtn"
                  :class="selectCategorieUid.indexOf(item.categoryId) > -1 || moreOptionsId.indexOf(item.categoryId) > -1 ? 'check' : ''"
                >
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
          <div class="nfBtn">
            <button class="entryBtn" @click="handleClick">
              {{ btnTitle }}
            </button>
          </div>
        </div>
      </div>
      <div class="provinceBox" v-if="isProvince">
        <div class="proviceTitle">请选择城市</div>
        <div class="cityBox">
          <div
            class="cityList"
            v-for="(item, idx) in provinceArr"
            :class="selectedCity.value === item.value ? 'activeCity' : ''"
            :key="idx"
            @click="chooseCity(item)"
          >
            {{ item.value }}
          </div>
        </div>
        <div class="closeCityIcon" @click="provinceClose">
          <img src="../../assets/images/icon_city_close.png" alt="" class="images" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex' // mapActions
import { getOpenPageResult } from '@/server/interfaces'
import { cityList } from '@/utils/cityList'
import { initShare } from '@/utils/share'
import { buryingPoint } from '@/utils/buryingPoint'

export default {
  name: 'entryPage',
  data() {
    return {
      isProvince: false,
      btnTitle: '跳过，马上进入',
      activeCity: '',
      selectCateList: [],
      provinceArr: cityList,
      isold: true, //是否是旧数据
      coverUrl: '',
      finish:false,
    }
  },
  watch: {
    selectCategorieUid: {
      handler(newArr) {
        let title = '跳过，马上进入'
        if (newArr.length > 0) {
          title = '选好了，进入'
        } else {
          title = '跳过，马上进入'
        }
        this.btnTitle = title
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      selectedCity: 'home/selectedCity',
      selectCategorieUid: 'home/selectCategorieUid',
      activityInfo: 'activityInfo/activityInfo',
      activityId: 'activityInfo/activityId',
      moreOptionsId: 'home/moreOptionsId'
    })
  },
  created() {
    this.init()
    buryingPoint({ action: 1, sourceTag: 1, activityId: this.activityId, itemType: 2 })
  },
  methods: {
    ...mapMutations({
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
      setSelectedCity: 'home/setSelectedCity',
      setSelectCategorieUid: 'home/setSelectCategorieUid',
      setMoreOptionsId: 'home/setMoreOptionsId',
      setShareInfo: 'activityInfo/setShareInfo'
    }),
    ...mapActions({
      initNfPluseShare: 'activityInfo/initNfPluseShare'
    }),
    async init() {
      const data = {
        params: {
          id: this.activityId
        }
      }
      const result = await getOpenPageResult(data)
      const list = result.list || []
      this.isold = !Object.keys(result).includes('coverUrl')
      this.finish=true
      this.coverUrl = !this.isold && result.coverUrl ? result.coverUrl : ''
      const arr = []
      list.forEach(item => {
        if (item.topLevel) {
          arr.push(item.categoryId)
        }
      })
      this.setSelectCategorieUid(arr[0])
      this.selectCateList = list
      this.setAllShareInfo()
    },
    async setAllShareInfo() {
      this.setShareInfo({
        title: this.activityInfo.share.shareTitle,
        desc: this.activityInfo.share.shareDesc,
        link: window.location.href,
        imgUrl: this.activityInfo.share.shareIcon
      })
      try {
        await this.initNfPluseShare()
      } catch (e) {
        console.log(e)
      }
      try {
        await initShare({
          shareTitle: this.activityInfo.share.shareTitle,
          shareUrl: window.location.href,
          shareIcon: this.activityInfo.share.shareIcon,
          shareDesc: this.activityInfo.share.shareDesc
        })
      } catch (e) {
        console.log(e)
      }
    },
    handleClick() {
      this.$router.push({ path: '/homePage', query: { id: this.activityId } })
    },
    openCity() {
      this.isProvince = true
      buryingPoint({ action: 2, sourceTag: 1, activityId: this.activityId, itemType: 2 })
    },
    chooseTab(info) {
      if (info.topLevel) {
        // 顶级分类逻辑
        this.setSelectCategorieUid(info.categoryId)
      } else {
        // 子分类逻辑
        // if (this.selectCategorieUid.indexOf(info.topId) > -1) {
        this.setSelectCategorieUid(info.topId)
        this.setMoreOptionsId(info.categoryId)
        // }
      }
      buryingPoint({ action: 3, sourceTag: 1, optionName: info.text, activityId: this.activityId, itemType: 2 })
    },
    provinceClose() {
      this.isProvince = false
      buryingPoint({ action: 5, sourceTag: 1, activityId: this.activityId, itemType: 2 })
    },
    chooseCity(info) {
      this.setSelectedCity(info)
      this.isProvince = false
      buryingPoint({ action: 4, sourceTag: 1, optionName: info.value, activityId: this.activityId, itemType: 2 })
    }
  }
}
</script>
<style lang="scss">
.red-map-coverImg {
  height: 100%;
}
.entryPageCust {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: relative;
  .entry-map {
    position: absolute;
    left: 50%;
    top: 85%;
    width: 3.14rem;
    height: 0.75rem;
    transform: translateX(-50%);
    background: #169bd5;
    color:#fff;
    border-radius: 0.38rem;
     font-family: PingFang-SC-Bold;
    font-size: 0.3rem;
    outline: none;
    border: none;
    line-height: 0.75rem;
    text-align: center;
  }
}
.entryPageBox {
  width: 100%;
  height: 100vh;
  background: url('../../assets/images/bg_entry.png') no-repeat center center;
  background-size: cover;
  position: relative;
  .centuryYearBox {
    position: absolute;
    left: 50%;
    top: 0;
    background-size: cover;
    transform: translate(-50%, 0);
    .images {
      width: 7.5rem;
    }
  }
  .content {
    position: relative;
    height: 100%;
    .mainBox {
      position: absolute;
      left: 50%;
      top: 77%;
      transform: translate(-50%, -50%);
    }
  }
  .tabBox {
    background: #ffdab4;
    border-radius: 0.2rem;
    width: 6.8rem;
    min-height: 2.67rem;
    .tabTitle {
      padding: 0.3rem 0 0.25rem 0;
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      line-height: 0.42rem;
      text-align: center;
      color: #b23f00;
      letter-spacing: 0;
    }
    .tabMainBox {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      padding: 0 0.4rem;
      .tabList {
        margin-right: 0.2rem;
        cursor: pointer;
      }
      .tabListBtn {
        border: 0.02rem solid #c41b1b;
        border-radius: 0.38rem;
        width: 1.8rem;
        padding: 0 0.12rem;
        height: 0.6rem;
        box-sizing: border-box;
        line-height: 0.6rem;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        color: #c41b1b;
        letter-spacing: 0;
        cursor: pointer;
        margin-bottom: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .check {
        background-image: linear-gradient(180deg, #ff601a 0%, #dc0808 100%);
        border-radius: 0.38rem;
        color: #fff;
        border: 0 none;
      }
      .tabListSelect {
        border-radius: 0.38rem;
        width: 1.8rem;
        height: 0.6rem;
        box-sizing: border-box;
        line-height: 0.6rem;
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        text-align: center;
        color: #fff;
        letter-spacing: 0;
        cursor: pointer;
        margin-bottom: 0.2rem;
        background-image: linear-gradient(180deg, #ff601a 0%, #dc0808 100%);
        .selectIcon {
          background: url('../../assets/images/icon_down_white.png') no-repeat center center;
          background-size: 100%;
          display: inline-block;
          width: 0.22rem;
          height: 0.12rem;
        }
      }
      .tabListBtn:nth-child(3n) {
        margin-right: 0;
      }
    }
    .tabMainBox:after {
      content: '';
      flex: auto;
      width: 1.8rem;
      height: 0.6rem;
    }
  }
  .nfBtn {
    height: 0.75rem;
    width: 100%;
    position: relative;
    margin-top: 0.4rem;
  }
  .entryBtn {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 3.14rem;
    height: 0.75rem;
    background-image: linear-gradient(180deg, #ff9f00 0%, #ff601a 100%);
    border-radius: 0.38rem;
    color: #ffffff;
    font-family: PingFang-SC-Bold;
    font-size: 0.3rem;
    outline: none;
    border: none;
    line-height: 0.75rem;
    text-align: center;
  }
  .provinceBox {
    position: fixed;
    transform: translate(-50%, 0);
    background: #ffdab4;
    border-radius: 0.2rem 0.2rem 0 0;
    width: 6.8rem;
    height: 5.83rem;
    animation: cityAnimation 0.3s linear;
    -webkit-animation: cityAnimation 0.3s linear;
    animation-fill-mode: forwards;
    .proviceTitle {
      margin-top: 0.3rem;
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      line-height: 0.42rem;
      color: #b23f00;
      letter-spacing: 0;
      text-align: center;
    }
    .cityBox {
      margin-top: 0.3rem;
      display: flex;
      flex-wrap: wrap;
      padding: 0 0.2rem;
      .cityList {
        margin-right: 0.2rem;
        border: 0.02rem solid #c41b1b;
        border-radius: 0.3rem;
        width: 1.45rem;
        height: 0.6rem;
        box-sizing: border-box;
        text-align: center;
        line-height: 0.6rem;
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        color: #c41b1b;
        letter-spacing: 0;
        margin-bottom: 0.2rem;
      }
      .cityList:nth-child(4n) {
        margin-right: 0;
      }
      .activeCity {
        border: 0 none;
        color: #fff;
        background-image: linear-gradient(180deg, #ff601a 0%, #dc0808 100%);
      }
    }
    .closeCityIcon {
      width: 0.34rem;
      height: 0.34rem;

      // background: url("../../assets/images/icon_city_close.png") no-repeat center center;
      position: absolute;
      right: 0.2rem;
      top: 0.2rem;
      cursor: pointer;
      .images {
        display: block;
        width: 0.34rem;
        height: 0.34rem;
      }
    }
  }
  @keyframes cityAnimation {
    0% {
      left: 50%;
      bottom: -5.83rem;
    }
    25% {
      left: 50%;
      bottom: -4.4rem;
    }
    50% {
      left: 50%;
      bottom: -3rem;
    }
    75% {
      left: 50%;
      bottom: -1.5rem;
    }
    100% {
      left: 50%;
      bottom: 0;
    }
  }
  @-webkit-keyframes cityAnimation /* Safari and Chrome */ {
    0% {
      left: 50%;
      bottom: -5.83rem;
    }
    25% {
      left: 50%;
      bottom: -4.4rem;
    }
    50% {
      left: 50%;
      bottom: -3rem;
    }
    75% {
      left: 50%;
      bottom: -1.5rem;
    }
    100% {
      left: 50%;
      bottom: 0;
    }
  }
}
</style>
